import "babel-polyfill"; // has to be the first imported!
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

import React from "react";
import ReactDOM from "react-dom";

import "@pro/assets/scss/App.scss";

import { Root } from "@pro/root";
import { unregister } from "@pro/registerServiceWorker";

ReactDOM.render(<Root />, document.getElementById("root"));
unregister();
// registerServiceWorker();
